/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/DraftWIFEndpointComponent" />

import React = require("react");

import { StoreManager } from "DistributedTask/Flux/StoreManager";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { InputValidationStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/InputValidationStore";
import "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointEditorStoreExtensions";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { BackButton } from "../Common/BackButton";
import { EndpointDescriptionInput } from "../Common/EndpointDescriptionInput";
import { EndpointErrorMessageWidget } from "../Common/EndpointErrorMessageWidget";
import { EndpointNameInput } from "../Common/EndpointNameInput";
import { SaveDraftEndpointButton } from "./SaveDraftEndpointButton";
import { IdentityCredentialTypeComponent } from "./IdentityCredentialTypeComponent";
import { WIFEndpointFooterComponent } from "./WIFEndpointFooterComponent";


interface IDraftWIFEndpointComponentState {
    isEndpointValid: boolean;
}

export class DraftWIFEndpointComponent extends VssComponent<{}, IDraftWIFEndpointComponentState> {

    private readonly _validationStore: InputValidationStore;

    private readonly _validationScopeId = DraftWIFEndpointComponent.name;

    constructor(context: IVssComponentContext) {
        super(context);

        this._validationStore = StoreManager.GetStore<InputValidationStore>(InputValidationStore, this._validationScopeId);
        this._validationStore.addChangedListener(this._onValidationStoreChanged);

        this.state = {
            isEndpointValid: false
        };
    }

    public componentWillUnmount(): void {
        this._validationStore.removeChangedListener(this._onValidationStoreChanged);
        StoreManager.DeleteStore<InputValidationStore>(InputValidationStore, this._validationScopeId);
    }

    public render(): React.ReactNode {

        return (<React.Fragment>
            <IdentityCredentialTypeComponent />
            <div role="heading" aria-level={4} className="service-endpoint-step-header">{Resources.WorkloadIdentityFederationStep1Title}</div>

            <EndpointNameInput validationScopeId={this._validationScopeId} />
            <EndpointDescriptionInput validationScopeId={this._validationScopeId} />

            <EndpointErrorMessageWidget />

            <WIFEndpointFooterComponent renderButtons={this._renderButtonSection} />
        </React.Fragment>);
    }

    private _onValidationStoreChanged = (): void => {
        const state = this._validationStore.getState();
        this.setState({
            isEndpointValid: state.isValid
        });
    }

    private _renderButtonSection = (): JSX.Element => {
        return (<React.Fragment>
            <BackButton />
            <SaveDraftEndpointButton
                closeUponSuccess={false}
                disabled={!this.state.isEndpointValid}
                isUpdateFlow={false}
                className="next-button"
                primary
                text={Resources.NextText} />
        </React.Fragment>);
    }
}

